import { APICore } from './apiCore'

const api = new APICore()

function getProcedencias (params) {
  const baseUrl = '/procedencias'
  return api.get(baseUrl, params)
}

function getProcedencia (id) {
  const baseUrl = `/procedencias/${id}`
  return api.get(baseUrl, {})
}

function addProcedencia (params) {
  const baseUrl = '/procedencias'
  return api.createWithFile(baseUrl, params)
}

function updateProcedencia (params) {
  const baseUrl = '/procedencias'
  return api.updateWithFile(baseUrl, params)
}

function deleteProcedencia (params) {
  const baseUrl = '/procedencias'
  return api.delete(baseUrl, params)
}

export { getProcedencias, getProcedencia, addProcedencia, updateProcedencia, deleteProcedencia }
